import React, { useState } from 'react';
import '../styles/Notificacao.css';

const Notification: React.FC<{ message: string }> = ({ message }) => {
  const [visible, setVisible] = useState(true);

  React.useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 3000); // Desaparece após 3 segundos
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="notification">
      {message}
    </div>
  );
};

export default Notification;
